/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const paginateLimit = 10;

export const cookieUserId = document.cookie.replace(
  /(?:(?:^|.*;\s*)userId\s*=\s*([^;]*).*$)|^.*$/,
  "$1",
);
export const cookieRoleId = document.cookie.replace(
  /(?:(?:^|.*;\s*)roleId\s*=\s*([^;]*).*$)|^.*$/,
  "$1",
);

export const baseApi = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/`;
export const connectorApi = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/connector_details`;
export const connectorDetailsApi = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/connector/list`;
export const connectorApiById = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/connector_customer_maps?customer_code=`;
export const connectorAddEdit = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/connectorCustomerMap`;
export const connectorDelete = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/connectorCustomerMap/delete?connector_config_id=`;
export const aggregationApi = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v2`;
export const baseApiV2 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v2/`;
export const baseApiV2_1 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v2.1/`;
export const baseApiV2_2 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v2.2/`;
export const baseApiV1 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1/`;
export const baseApiV1_2 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1.2/`;
export const baseApiV1_1 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v1.1/`;
export const baseApiV3 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v3/`;
export const baseApiV3_1 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v3.1/`;
export const baseApiV3_2 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v3.2/`;
export const baseApiV3_3 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v3.3/`;
export const baseApiV3_4 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v3.4/`;
export const clientApiV2 = `${process.env.REACT_APP_ADMIN_BACKEND_API}admin-backend/v2/players`;
export const cardAddApi = `${baseApiV2}stripe/create`;
export const getRatesApi = `${baseApiV2}stripe/getCustomRates?`;
export const getStandadRatesApi = `${baseApiV2}stripe/getStandardRates?`;
export const setCustomRatesApi = `${baseApiV2}stripe/setCustomRate`;
export const setStandardRatesApi = `${baseApiV2}stripe/setStandardRate`;
export const updateCustomRatesApi = `${baseApiV2}stripe/editCustomRate`;
export const updateStandardRatesApi = `${baseApiV2}stripe/editStandardRate`;
export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const creditHistoryApi = `${baseApiV2}credit/creditHistory`;
export const billingHistoryApi = `${baseApiV2}billing/history`;
export const creditAdjustmentApi = `${baseApiV2}credit/modifyCredit`;
export const oauth2AuthorizationApi = `${baseApi}`;
